import clsx from "clsx";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext } from "@ryde/redux";
import {
  displayedRowsCountSF,
  selectedTableDataCountSF,
  useIsMobile,
} from "@ryde/shared";

import { HeaderBottomLeftControls } from "../bottom-line";
import { EditGridColumnButton, PanelTopRightStatItem } from "../elements";
import {
  CheckedItemsIcon,
  PanelStatStyled,
  TableRowsCountIcon,
} from "./panel-top.stat.styled";

interface IPanelTopStatCommonProps {
  embeddedInSearchMobileLine?: boolean;
}

export const PanelTopStatCommon: FC<IPanelTopStatCommonProps> = ({
  embeddedInSearchMobileLine = false,
}) => {
  const { isMobile } = useIsMobile();
  const { entity } = usePageContext();
  const rowsCount = useRecoilValue(displayedRowsCountSF(entity));
  const selectedRowsCount = useRecoilValue(selectedTableDataCountSF(entity));
  const useMobileSearchLineLayout = embeddedInSearchMobileLine && isMobile;

  const statItems = (
    <>
      <PanelTopRightStatItem
        e2eId="stat-rows-count"
        selected={rowsCount}
        hideTotal={true}
        label={<TableRowsCountIcon />}
      />
      <PanelTopRightStatItem
        e2eId="stat-selected-rows-count"
        selected={selectedRowsCount}
        hideTotal={true}
        label={<CheckedItemsIcon />}
      />
    </>
  );

  return (
    <PanelStatStyled
      className={clsx({
        panel_stat_embedded: useMobileSearchLineLayout,
      })}
    >
      {useMobileSearchLineLayout ? (
        <>
          <HeaderBottomLeftControls />
          {statItems}
          <div className="stat_panel_end">
            <EditGridColumnButton />
          </div>
        </>
      ) : (
        <>
          {statItems}
          {Boolean(isMobile) && <HeaderBottomLeftControls />}
          {Boolean(isMobile) && (
            <div className="stat_panel_end">
              <EditGridColumnButton />
            </div>
          )}
        </>
      )}
    </PanelStatStyled>
  );
};
